import { Box } from '@packages/shared';
// eslint-disable-next-line import/no-cycle
import ComponentRecognizerFooter from './ComponentRecognizerFooter';
import type { FooterBlockBadgesType } from './types';

type BlockBadgesProps = {
  data: FooterBlockBadgesType;
};

export enum BlockBadgesTestIds {
  main = 'block-badges',
}

const BlockBadges = ({ data }: BlockBadgesProps) => (
  <Box
    sx={{
      display: 'flex',
      gap: '0.8rem',
    }}
    data-testid={BlockBadgesTestIds.main}
    key={`${BlockBadgesTestIds.main}-${data.id}`}
  >
    {data.paragraph?.map((item, index) => {
      const currentKey = `${BlockBadgesTestIds.main}-component-recognizer-${index}`;
      return <ComponentRecognizerFooter key={currentKey} item={item} />;
    })}
  </Box>
);

// eslint-disable-next-line import/no-default-export
export default BlockBadges;
